import Vue from 'vue';
import { Address } from '@/models/address';
import { ContactDetails } from '@/models/order';
import { CompanyDetails } from '@/models/companyDetails';
import FriendHelpers, { Friend } from '@/models/friend';

const shortCurrency: any = {
  ZAR: (v: string) => `R ${v}`,
  USD: (v: string) => `$ ${v}`,
};

Vue.filter('currency', (value: any, currency: any, digits: number) => {
  if (!value) { return ''; }

  const v = String(Number(value).toFixed(digits === undefined ? 2 : digits)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  if (currency in shortCurrency) { return shortCurrency[currency](v); }
  return v;
});

Vue.filter('address', (a: Address) => {
  if (!a) { return ''; }

  if (a.type === 'pickup') {
    return 'Client pick up';
  }

  if (a.type === 'consultant_to_deliver') {
    return 'Sales consultant to deliver';
  }

  return (a.line1 ? a.line1 + ', ' : '') +
    (a.postal_code ? a.postal_code + ', ' : '') +
    (a.region ? a.region + ', ' : '') +
    (a.city ? a.city + ', ' : '') +
    (a.country ? a.country : '');
});


Vue.filter('contact_details', (a: ContactDetails) => {
  if (!a) { return ''; }

  return (a.name ? a.name : '') +
    (a.name && a.number ? ': ' : '') +
    (a.number ? a.number : '');
});

Vue.filter('company_details', (a: CompanyDetails) => {
  if (!a) { return ''; }

  return (a.name ? a.name : '') +
    (a.vat_number ? '(' + a.vat_number + ')' : '') +
    (a.registration_number ? '(' + a.registration_number + ')' : '');
});

Vue.filter('friends_list', (a: Friend[]) => {
  if (!a || !a.length) { return ''; }

  let res = '';
  for (const f of a) {
    if (!FriendHelpers.Valid(f)) { continue; }
    res += `${f.name} (${f.email})<br>`;
  }
  return res;
});

const IntervalOptions: any = {
  once: 'Once-Off',
  month: 'Monthly',
  year: 'Annual',
  trial: 'Trial'
};
Vue.filter('friendly_interval', (a: string) => {
  if (!a || !(a in IntervalOptions)) { return IntervalOptions.once; }

  return IntervalOptions[a];
});

Vue.filter('percentage', (a: any) => {
  a = Number(a);
  if (!a) { return ''; }

  if (a < 1) {
    return Math.round(a * 100) + " %";
  }
  if (a < 101) {
    return Math.round(a) + " %";
  }
});

Vue.filter('pretty', (a: any) => {
  return JSON.stringify(a, null, 2);
});
